import { useAuth } from "../../../contexts/auth";
import React, {
    useEffect,
    useState, useCallback
} from "react";
import AccessDenied from "../../../components/access-denied/access-denied";
import LoadPanel from "devextreme-react/load-panel";
import {verifyAccess} from "../../../utils/admin.utils";
import { Button, SelectBox } from 'devextreme-react';
import {getMaintenanceStatus, toggleMaintenance} from "../../../api/maintenance";
import notify from "devextreme/ui/notify";
import {getHHmmddMMyyyy} from "../../../utils/date.utils";

const  AdminMaintenancePage = () => {
    const [selectedHours, setSelectedHours] = useState(1);
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const { selectedDog } = useAuth();
    const [visiblePage, setVisiblePage] = useState(true);
    //const [maintenanceStatus, setMaintenanceStatus] = useState(null);

    useEffect(() => {
        const pageRoles = [1]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
        } else setVisiblePage(true)
    }, [selectedDog])

    useEffect(() => {
        (async function () {
            try {
                const res = await getMaintenanceStatus()
                //setMaintenanceStatus(res?.data)
                if (res?.data?.isActive) {
                    setStatusMessage( {type: 'success', text: `Режим обслуживания включен до ${getHHmmddMMyyyy(res?.data?.endTime)}`} );
                }
            } catch (e) {
                notify(e.message, 'error', 5000)
            }
        })()
    }, [])

    // Опции для селекта
    const hoursOptions = Array.from({ length: 10 }, (_, i) => ({
        value: i + 1,
        text: `${i + 1} ${getHoursWord(i + 1)}`
    }));

    // Склонение слова "час"
    function getHoursWord(n) {
        const lastTwo = n % 100;
        const last = n % 10;

        if (lastTwo >= 11 && lastTwo <= 14) return 'часов';
        if (last === 1) return 'час';
        if (last >= 2 && last <= 4) return 'часа';
        return 'часов';
    }

    // Отправка команды на сервер
    const sendCommand = useCallback(async (action) => {
        setLoading(true);
        setStatusMessage('');

        try {
            const res = await toggleMaintenance(action, action !== 'stop' ? selectedHours : null)

            if (res.isOk) {
                const messages = {
                    start: `Режим обслуживания включен на ${selectedHours} ${getHoursWord(selectedHours)} до ${getHHmmddMMyyyy(res?.data?.endTime)}`,
                    stop: 'Режим обслуживания отключен',
                    extend: `Время продлено на ${selectedHours} ${getHoursWord(selectedHours)} до ${getHHmmddMMyyyy(res?.data?.endTime)}`
                };
                setStatusMessage({ type: 'success', text: messages[action] });
                //notify(res.data.message, 'success', 5000);
            } else {
                setStatusMessage({ type: 'error', text: res.message || 'Ошибка выполнения команды' });
                //notify(res.message, 'error', 5000);
            }
        } catch (error) {
            setStatusMessage({
                type: 'error',
                text: 'Ошибка соединения с сервером: ' + error.message
            });
            notify(error.message, 'error', 5000);
        } finally {
            setLoading(false);
        }
    }, [selectedHours]);

    // Обработчики кнопок
    const handleStart = useCallback(() => sendCommand('start'), [sendCommand]);
    const handleStop = useCallback(() => sendCommand('stop'), [sendCommand]);
    const handleExtend = useCallback(() => sendCommand('extend'), [sendCommand]);

    // Обработчик изменения селекта
    const handleHoursChange = useCallback((e) => {
        setSelectedHours(e.value);
    }, []);

/*    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow">
                        <div className="card-header bg-primary text-white">
                            <h4 className="mb-0">
                                <i className="dx-icon-tool"></i> Сервисное обслуживание сайта
                            </h4>
                        </div>

                        <div className="card-body">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};*/


    return (
        <>{visiblePage ?
            <div className={'content-block dx-card responsive-paddings'}>
                <i className="dx-icon dx-icon-video icon-header-h3 main-color main-color-light"/>
                <h3>
                    <strong>Сервисное обслуживание</strong>
                </h3>

                {/* Адаптивная сетка: на мобильных - в столбик, на десктопе - в строку */}
                <div className="row align-items-center">
                    {/* Селект: на мобильных - вся ширина, на десктопе - 4 колонки */}
                    <div className="col-12 col-md-4 mb-3 mb-md-0">
                        <SelectBox
                            label={'Длительность:'}
                            items={hoursOptions}
                            value={selectedHours}
                            valueExpr="value"
                            displayExpr="text"
                            onValueChanged={handleHoursChange}
                            disabled={loading}
                            width="100%"
                            labelMode='floating'
                        />
                    </div>

                    {/* Кнопки: на мобильных - вся ширина, на десктопе - 8 колонок */}
                    <div className="col-12 col-md-8">
                        {/* На мобильных: flex-column (в столбик), на десктопе: flex-row (в ряд) */}
                        <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center">
                            {/* Кнопка Старт */}
                            <div className="mb-2 mb-md-0 mr-md-2 w-100 w-md-auto">
                                <Button
                                    text="Старт"
                                    icon="video"
                                    type="success"
                                    stylingMode="contained"
                                    onClick={handleStart}
                                    disabled={loading}
                                    width="100%"
                                    className="btn-responsive"
                                />
                            </div>

                            {/* Кнопка Стоп */}
                            <div className="mb-2 mb-md-0 mr-md-2 w-100 w-md-auto">
                                <Button
                                    text="Стоп"
                                    icon="clear"
                                    type="danger"
                                    stylingMode="contained"
                                    onClick={handleStop}
                                    disabled={loading}
                                    width="100%"
                                    className="btn-responsive"
                                />
                            </div>

                            {/* Кнопка Продлить */}
                            <div className="w-100 w-md-auto">
                                <Button
                                    text="Продлить"
                                    icon="redo"
                                    type="primary"
                                    stylingMode="contained"
                                    onClick={handleExtend}
                                    disabled={loading}
                                    width="100%"
                                    className="btn-responsive"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Индикатор загрузки */}
                {loading && (
                    <div className="alert alert-info d-flex align-items-center mt-3" role="alert">
                        <div className="spinner-border spinner-border-sm mr-2" role="status">
                            <span className="sr-only">Загрузка...</span>
                        </div>
                        Выполнение команды...
                    </div>
                )}

                {/* Сообщение о результате */}
                {statusMessage && !loading && (
                    <div
                        className={`alert alert-${statusMessage.type} d-flex align-items-center mt-3`}
                        role="alert"
                    >
                        <i className={`dx-icon-${statusMessage.type === 'success' ? 'check' : 'close'} mr-2`}></i>
                        {statusMessage.text}
                    </div>
                )}

                {/* Предупреждение */}
                <div className="alert alert-warning mt-3" role="alert">
                    <i className="dx-icon-attention mr-2"></i>
                    <strong>Внимание!</strong> Во время сервисного обслуживания сайт будет недоступен для пользователей.
                </div>

                <LoadPanel visible={loading} />
            </div>


            : <AccessDenied/>}</>
    )
};

export default AdminMaintenancePage;
